import {Injectable} from '@angular/core';
import {TableInfo} from '../../../models/tableInfo';
import {AboutCedlab} from '../../../models/AboutCedlab';

@Injectable({
  providedIn: 'root'
})
export class AboutcedlabStore {
  aboutCedlab: AboutCedlab[];

  constructor() {
    this.aboutCedlab = [];
  }

  loadInfo(aboutCedlab: AboutCedlab[]) {
    this.aboutCedlab = aboutCedlab;
  }

  updateInfo(toUpdate: AboutCedlab) {
    const index = this.aboutCedlab.indexOf(toUpdate);
    this.aboutCedlab[index].descrizione = toUpdate.descrizione;
  }
}
